import { Validators } from '@angular/forms';

export class FormInfo {
  validators: Validators;
  disabled: boolean;
  constructor(required: boolean, validator: Validators) {
    this.disabled = required;
    this.validators = validator;
  }
}
export const TVAVALIDATORS = {
    CREATE: new Map<string, FormInfo>([
      ['id', new FormInfo(false, [])],
      ['dCreation', new FormInfo(true, [])],
      ['idCreateur', new FormInfo(true, [])],
      ['dModification', new FormInfo(true, [])],
      ['idModifieur', new FormInfo(true, [])],
      ['dDesactivation', new FormInfo(true, [])],
      ['code', new FormInfo(false, [Validators.required, Validators.maxLength(2)])],
      ['libelle', new FormInfo(false, [Validators.required])],
      ['autoIntra', new FormInfo(false, [Validators.required])],
      ['taux', new FormInfo(false, [Validators.required])],
      ['compteOd1', new FormInfo(false, [Validators.maxLength(12)])],
      ['compteOd2', new FormInfo(false, [Validators.required, Validators.maxLength(12)])],
      ['compteFact1', new FormInfo(false, [Validators.required, Validators.maxLength(12)])],
      ['compteFact2', new FormInfo(true, [Validators.maxLength(12)])],
      ['compteCompta', new FormInfo(false, [Validators.required, Validators.maxLength(12)])],
      ['compteCompta2', new FormInfo(true, [Validators.maxLength(12)])],
      ['factNTH', new FormInfo(false, [Validators.maxLength(12)])],
      ['odNTH', new FormInfo(false, [Validators.maxLength(12)])]

    ]),
    EDIT: new Map<string, FormInfo>([
      ['id', new FormInfo(false, [])],
      ['dCreation', new FormInfo(true, [])],
      ['idCreateur', new FormInfo(true, [])],
      ['dModification', new FormInfo(true, [])],
      ['idModifieur', new FormInfo(true, [])],
      ['dDesactivation', new FormInfo(true, [])],
      ['code', new FormInfo(true, [Validators.required, Validators.maxLength(2)])],
      ['libelle', new FormInfo(false, [Validators.required])],
      ['autoIntra', new FormInfo(false, [Validators.required])],
      ['taux', new FormInfo(false, [Validators.required])],
      ['compteOd1', new FormInfo(false, [Validators.maxLength(12)])],
      ['compteOd2', new FormInfo(false, [Validators.required, Validators.maxLength(12)])],
      ['compteFact1', new FormInfo(false, [Validators.required, Validators.maxLength(12)])],
      ['compteFact2', new FormInfo(false, [Validators.maxLength(12)])],
      ['compteCompta', new FormInfo(false, [Validators.required, Validators.maxLength(12)])],
      ['compteCompta2', new FormInfo(false, [Validators.maxLength(12)])],
      ['factNTH', new FormInfo(false, [Validators.maxLength(12)])],
      ['odNTH', new FormInfo(false, [Validators.maxLength(12)])]
    ]),
    VISUALIZE: new Map<string, FormInfo>([
      ['id', new FormInfo(false, [])],
      ['dCreation', new FormInfo(true, [])],
      ['idCreateur', new FormInfo(true, [])],
      ['dModification', new FormInfo(true, [])],
      ['idModifieur', new FormInfo(true, [])],
      ['dDesactivation', new FormInfo(true, [])],
      ['code', new FormInfo(false, [Validators.required, Validators.maxLength(2)])],
      ['libelle', new FormInfo(false, [Validators.required])],
      ['autoIntra', new FormInfo(false, [Validators.required])],
      ['taux', new FormInfo(false, [Validators.required])],
      ['compteOd1', new FormInfo(false, [Validators.maxLength(12)])],
      ['compteOd2', new FormInfo(false, [Validators.maxLength(12)])],
      ['compteFact1', new FormInfo(false, [Validators.maxLength(12)])],
      ['compteFact2', new FormInfo(false, [Validators.maxLength(12)])],
      ['compteCompta', new FormInfo(false, [Validators.maxLength(12)])],
      ['compteCompta2', new FormInfo(false, [Validators.maxLength(12)])],
      ['factNTH', new FormInfo(false,[Validators.maxLength(12)])],
      ['odNTH', new FormInfo(false, [Validators.maxLength(12)])]
    ])
  };
